import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54a97bf5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cos-form-item-detail"
}
const _hoisted_2 = { class: "multiple-select" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "cos-form-item-detail cos-form-item-input-detail"
}
const _hoisted_5 = ["title"]

import { computed, useAttrs } from 'vue'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'CosSelectView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: [String, Number, Array]
  },
  cosDes: {
    type: [String, Number]
  },
  cosBeforeDes: {
    type: [String, Number]
  },
  options: {
    type: Array
  }
},
  setup(__props) {

const { t } = useI18n()
const attrs = useAttrs()
const props = __props
const valuePage = computed(() => {
  // 是否有options
  const fieldNames: any = attrs.fieldNames
  const options: any = props.options
  const { mode } = attrs
  const labelKey = fieldNames && fieldNames.label ? fieldNames.label : 'label'
  const valKey = fieldNames && fieldNames.value ? fieldNames.value : 'value'
  if (options) {
    if (mode === 'multiple') {
      const resultLabel: any = []
      if (props.value && Array.isArray(props.value)) {
        props.value.forEach((item) => {
          const findv = options.find((v: any) => v[valKey] === item)
          if (findv) {
            if (findv.lang) {
              resultLabel.push(t(findv.lang))
            } else {
              resultLabel.push(findv[labelKey])
            }
          } else {
            resultLabel.push(item)
          }
        })
      }
      return resultLabel
    } else {
      const findv = options.find((item: any) => item[valKey] === props.value)
      let txt = props.value || ''
      if (findv) {
        txt = findv.lang ? t(findv.lang) : findv[labelKey]
      }
      if (props.cosBeforeDes || props.cosDes === 0) {
        txt = props.cosBeforeDes + ' ' + txt
      }
      if (props.cosDes || props.cosDes === 0) {
        if (txt) {
          txt += ` - ${props.cosDes}`
        } else {
          txt = props.cosDes
        }
      }
      if (txt == null || txt === '') {
        txt = '--'
      }
      return txt
    }
  }
  return props.value
})

return (_ctx: any,_cache: any) => {
  return (_unref(attrs).mode === 'multiple')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (valuePage.value && valuePage.value.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(valuePage.value, (item, index) => {
                return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(item) + "；", 1))
              }), 128))
            : (_openBlock(), _createElementBlock("p", _hoisted_3, "--"))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("p", {
          class: "input",
          title: valuePage.value
        }, _toDisplayString(valuePage.value), 9, _hoisted_5)
      ]))
}
}

})